import React, { useEffect, useState } from "react"
import Loader from "pages/Separate/Loader"
import moment from "moment"
import configure from "configure"
import { convertTimeZone } from "utils/common-helpers"
import { Tooltip } from "antd"
import { fetchData, FetchNodePostData, FetchPostData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"

const ProjectNotes = ({ stageData }) => {
    const [fixButtons, setFixButtons] = useState(false)
    const [loading, setLoading] = useState(false)
    const [datas, setDatas] = useState([])
    const [projectNotes, setProjectNotes] = useState([])
    const [checkedIds, setCheckedIds] = useState([]);
    const token = secureLocalStorage.getItem('auth_id')
    document.addEventListener("scroll", () => {
        if (window.scrollY > 160) {
            setFixButtons(true)
        } else {
            setFixButtons(false)
        }
    })

    useEffect(() => {
        const onGetNotes = async () => {
            const res = await fetchData(setLoading, `leadNotesData/${stageData?.lead_id}`, token);
            if (res?.success) {
                setDatas(res?.data?.notes)
            }
        }
        const getprojectNotes = async () => {
            const res = await fetchData(setLoading, `projectNotes/${stageData?.project_id}`, token);
            if (res?.success) {
                setProjectNotes(res?.data?.notes)
            }
        }
        onGetNotes()
        getprojectNotes()
    }, [])

    const onTransferNote = async (e) => {
        e.preventDefault();
        Swal.fire({
            icon: 'warning',
            title: "Are You sure?",
            text: "You want to transfer these notes to Project",
            showCancelButton: true,
            confirmButtonText: 'Yes, Transfer it!',
            cancelButtonText: 'No, cancel!',
        }).then(async (isOkay) => {
            if (isOkay?.isConfirmed) {
                const formEntries = {
                    NotesId: checkedIds,
                    projectId: stageData?.project_id,
                    userId: localStorage.getItem('auth_id'),
                    project_type: stageData?.project_type
                }
                const res = await FetchNodePostData(setLoading, 'addNotesToProject', token, formEntries);
                if (res?.data?.status) {
                    Swal.fire({
                        icon: "success",
                        text: "Notes added to project successfully"
                    })
                }
            }
        })
    }

    return (
        <React.Fragment>
            {loading && <Loader />}
            <div className="mb-3">
                <form className="px-3 py-4 bg-white" onSubmit={onTransferNote}>
                    <div className="d-flex justify-content-between position-relative note-filter">
                        <h5 className="text-dark">List of Notes need to add in project</h5>
                        <div >
                            <button
                                className="btn ms-md-2 btn-save btn-label"
                            >
                                <i className="fas fa-save me-1 label-icon"></i> save
                            </button>
                        </div>
                    </div>
                    <div className="mt-4">
                        <ul className="verti-timeline list-unstyled notes-box">
                            {datas?.map((note, key) => {
                                const isChecked = checkedIds.includes(note.id);

                                const handleCheckboxChange = (e) => {
                                    if (e.target.checked) {
                                        setCheckedIds((prev) => [...prev, note.id]);
                                    } else {
                                        setCheckedIds((prev) => prev.filter((id) => id != note.id));
                                    }
                                };
                                const matchFound = projectNotes?.some(
                                    (projectNote) => projectNote.description == note.description
                                );
                                return (
                                    <li key={key} className="event-list position-relative">

                                        <div className="event-timeline-dot">

                                            <img
                                                src={`${configure.imgUrl}${note.addedby_avatar}`}
                                                className="userImg me-3 "
                                                alt=""
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                                                <div className=" d-flex justify-content-between ">
                                                    <div>
                                                        <p className="text-muted cursor-pointer">
                                                            <h6 className="d-inline me-2">
                                                                By {note.added_by}
                                                            </h6>{" "}
                                                            <Tooltip
                                                                color="#f0e8f4"
                                                                title={
                                                                    <div className="text-purple fw-bold body-font fs-6">
                                                                        <div>UK Time: {convertTimeZone(note.created_at, "Europe/London", "DD-MM-YYYY hh:mm:ss a")}</div>
                                                                        <div>US Time : {convertTimeZone(note.created_at, "America/New_York", "DD-MM-YYYY hh:mm:ss a")}</div>
                                                                    </div>
                                                                }
                                                            >
                                                                {moment(note.created_at).format(
                                                                    "DD-MM-YYYY hh:mm:ss"
                                                                )}
                                                            </Tooltip>
                                                            <span className="pl-15">
                                                                Got in touch with this lead at{" "}
                                                                <Tooltip
                                                                    color="#f0e8f4"
                                                                    title={
                                                                        <div className="text-purple fw-bold body-font fs-6">
                                                                            <div>UK Time: {convertTimeZone(note.date, "Europe/London", "DD-MM-YYYY hh:mm:ss a")}</div>
                                                                            <div>US Time : {convertTimeZone(note.date, "America/New_York", "DD-MM-YYYY hh:mm:ss a")}</div>
                                                                        </div>
                                                                    }
                                                                >
                                                                    {moment(note.date).format('dddd')}{" "}
                                                                    {moment(note.date).format(
                                                                        "DD-MM-YYYY hh:mm a"
                                                                    )}
                                                                </Tooltip>
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <div className="text-end" id="customCheckbox">
                                                        <input type="checkbox" className="form-check-input custom-checkbox  mt-2im general-status" id="customCheck-0" value="complete"
                                                            defaultChecked={matchFound}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                    </div>
                                                </div>
                                                <i className="bi bi-triangle-fill note-icon"></i>
                                                <div
                                                    className="Features"
                                                    dangerouslySetInnerHTML={{
                                                        __html: note.description,
                                                    }}
                                                />
                                                <p className="mb-2">
                                                    Amount : {note.currency_symbol} {note.amount}{" "}
                                                </p>
                                                {note.link != null ? (
                                                    <p className="mb-1">
                                                        Attachment :{" "}
                                                        <a
                                                            target="_blank "
                                                            className="btn btn-sm edit-delete-btn text-secondary ml-10"
                                                            rel="noreferrer"
                                                            type="button"
                                                            href={note.link}
                                                            onClick={() =>
                                                                downloadImage({ imagelink: note.link })
                                                            }
                                                        >
                                                            <i className="fas fa-eye"></i> View
                                                        </a>
                                                    </p>
                                                ) : null}

                                                {/* Following code is for Static Video File */}
                                                <p className="mb-1">
                                                    Attachment :{" "}
                                                    <a
                                                        target="_blank "
                                                        className="btn btn-sm edit-delete-btn text-danger ml-10"
                                                        rel="noreferrer"
                                                        type="button"
                                                        href={"https://www.youtube-nocookie.com/embed/3S4fl7rpu3g?autoplay=0"}
                                                    // onClick={() =>
                                                    //   downloadImage({ imagelink: note.link })
                                                    // }
                                                    >
                                                        <i className="bi bi-record-circle recording-blink"></i> Open
                                                    </a>
                                                </p>

                                            </div>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                        {datas?.length == 0 ? (
                            <p>Note is Not Addded</p>
                        ) : null}
                    </div>

                </form>
            </div>
        </React.Fragment>
    )
}

export default ProjectNotes
